import styled from "styled-components"

const Style =styled.div`
  display: flex;
  background: #FEF3F2;
  border-radius: 16px;
  padding: 4px 10px;
  
  .bullet {
    background: #D92D20;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    margin-right: 4px;
  }

  p {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #D92D20;
  }

  &.success {
    background: #ECFDF3;
    .bullet {
      background: #039855;
    }
    p {
      color: #039855;
    }
  }

  &.medium {
    background: #FFFAEB;
    .bullet {
      background: #F8AB38;
    }
    p {
      color: #F8AB38;
    }
  }
`

export default function StatusTag({ children, type = 'default' }) {
  return (
    <Style className={type}>
      <div className="flex-c jus-c">
        <div className="bullet" />
      </div>
      <div className="flex-c jus-c">
        <p>{children}</p>
      </div>
    </Style>
  );
}
